import { CREATE_USER_FORM_GATE_ENTRY, FETCH_GATE_ENTRY_AGAINST_PODC_FAILURE, FETCH_GATE_ENTRY_AGAINST_PODC_REQUEST, FETCH_GATE_ENTRY_AGAINST_PODC_SUCCESS, FETCH_GATE_ENTRY_SCANNED_LIST_FAILURE, FETCH_GATE_ENTRY_SCANNED_LIST_REQUEST, FETCH_GATE_ENTRY_SCANNED_LIST_SUCCESS, FETCH_GATE_ENTRY_VISITORS_PODC_SUCCESS } from "./gateEntry.actionsType";


export const GATE_ENTRY = 'gateEntry';

let initialState = {
    loading: false,
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
    },
    scannedData: [],
    podcImageData: [],
    visitorsData: [],
    visitorsForm: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),

    }
}

export let gateEntryReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_GATE_ENTRY_SCANNED_LIST_REQUEST:
        case FETCH_GATE_ENTRY_AGAINST_PODC_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_GATE_ENTRY_SCANNED_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                scannedData: updatePayload
            }
        case FETCH_GATE_ENTRY_VISITORS_PODC_SUCCESS:
            return {
                ...state,
                loading: false,
                visitorsData: updatePayload

            }
        case FETCH_GATE_ENTRY_AGAINST_PODC_SUCCESS:
            return {
                ...state,
                loading: false,
                podcImageData: updatePayload
            }
        case FETCH_GATE_ENTRY_SCANNED_LIST_FAILURE:
        case FETCH_GATE_ENTRY_AGAINST_PODC_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_GATE_ENTRY:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },
            };
        default:
            return state;
    }
}
